export default {
  init() {
    $(".topic-slider").slick({
      dots: false,
      infinite: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      variableWidth: true,
      arrows: true,
      prevArrow: $("#topic-prev"),
      nextArrow: $("#topic-next"),
    });
  },

  finalize() {

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/postTypeArchiveLwResources.js